import React, { useState, useEffect } from "react";
import axios from "axios";
import Approved from "../../../assets/Icon/live.png";
import PromoFile from "./PromoFile";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const LivePromoVideo = () => {
  const [buffer, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [count, setLive] = useState("");

  console.log("event", event);

  useEffect(() => {
    axios.get(`/api/star/promoVideoLive`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
        setLive(res.data.liveTotal);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <>
        <AllDataHeader
          title={"Live Promo Video"}
          image={Approved}
          count={count}
        />
        {buffer ? <LoaderPost /> : <PromoFile data={event} />}
      </>
    </>
  );
};

export default LivePromoVideo;
